import { render, staticRenderFns } from "./teachingLevel.vue?vue&type=template&id=11f44d2f&scoped=true"
import script from "./teachingLevel.vue?vue&type=script&lang=js"
export * from "./teachingLevel.vue?vue&type=script&lang=js"
import style0 from "./teachingLevel.vue?vue&type=style&index=0&id=11f44d2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f44d2f",
  null
  
)

export default component.exports